import type { Course } from "../Menu/Menu.types";

const COURSE_PATH_PATTERN = /\/utbildning\/([^/]+)/;

export function resolveActiveEducationCourse(
  courses: Course[],
  selectedCourse: Course | null,
  pathname: string
): Course | null {
  const match = pathname.match(COURSE_PATH_PATTERN);
  if (match) {
    const courseFromUrl = courses.find((course) => course.ID === match[1]);
    if (courseFromUrl) {
      return courseFromUrl;
    }
  }

  return selectedCourse;
}
